module.exports = __webpack_public_path__ + "img/mount sinai.6c0eabca.png";